module.exports = __webpack_public_path__ + "fbbefb40231d56a05a53ca419e409712.svg";